import { render, staticRenderFns } from "./NotificationSettingSMSRequestDocs.vue?vue&type=template&id=359e0adb&scoped=true"
import script from "./NotificationSettingSMSRequestDocs.vue?vue&type=script&lang=js"
export * from "./NotificationSettingSMSRequestDocs.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingSMSRequestDocs.vue?vue&type=style&index=0&id=359e0adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e0adb",
  null
  
)

export default component.exports